<template>
  <div id="app">
    <div class="container">
      <div class="header">
        <a href="https://cs.mines.edu/" target="_blank">
          <img class="pure-img" src="./assets/CS_logo_small.jpg" alt="CS@Mines Logo"/>
        </a>
        <table>
          <tr>
            <td class="heading">CSCI 262: Data Structures</td>
            <td class="heading-right">Spring 2022</td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="$mq == 'sm' || $mq == 'md'" class="nav-mobile">
      <div class="hamburger">
        <a v-on:click="menuActive = !menuActive">
          <img src="./assets/toggle.png"/>
        </a>
      </div>
      <div v-if="menuActive" class="pure-menu">
        <ul class="pure-menu-list">
          <li class="pure-menu-item"><router-link to="/" class="pure-menu-link">&middot; CSCI 262 Home</router-link></li>
          <li class="pure-menu-item"><router-link to="/policies" class="pure-menu-link"> &middot; Policies</router-link></li>
          <li class="pure-menu-item"><router-link to="/schedule" class="pure-menu-link"> &middot; Schedule</router-link></li>
          <li class="pure-menu-item"><router-link to="/assignments" class="pure-menu-link"> &middot; Assignments</router-link></li>
          <li class="pure-menu-item"><router-link to="/labs" class="pure-menu-link"> &middot; Labs</router-link></li>
          <li class="pure-menu-item"><router-link to="/help" class="pure-menu-link"> &middot; Help!</router-link></li>
        </ul>
      </div>
    </div>
    <div v-else class="nav">
      <router-link to="/">CSCI 262 Home</router-link>
      &middot;
      <router-link to="/policies">Policies</router-link>
      &middot;
      <router-link to="/schedule">Schedule</router-link>
      &middot;
      <router-link to="/assignments">Assignments</router-link>
      &middot;
      <router-link to="/labs">Labs</router-link>
      &middot;
      <router-link to="/help">Help!</router-link>
    </div>
    <div class="container" id="main-body">
      <router-view/>
    </div>
    <div class="footer">
      <a href="https://cs.mines.edu/" target="_blank">
        <img class="pure-img logo" src="./assets/CS_mines_logo.png" alt="CS@Mines Logo"/>
      </a>
      <p>Copyright &copy; 2022 Christopher Painter-Wakefield</p>
    </div>
  </div>
</template>

<style>
  @import './assets/master.css';
</style>

<script>
export default {
  name: 'App',
  data() {
    return {
      menuActive: false
    }
  },
  watch: {
    '$route' () {
      this.menuActive = false;
    }
  }
}
</script>
